<template>
    <div class="mainForm">
        <div class="title"><h5>修改基本信息</h5></div>

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="真实姓名" prop="fullname"><el-input v-model="ruleForm.fullname" placeholder="请填写真实姓名"></el-input></el-form-item>
            <el-form-item label="联系电话" prop="mobile"><el-input v-model="ruleForm.mobile" placeholder="请填写联系电话"></el-input></el-form-item>
            <el-form-item label="邮箱" prop="email"><el-input v-model="ruleForm.email" placeholder="请填写邮箱"></el-input></el-form-item>
            <el-form-item label="QQ或微信" prop="qq_or_wechat"><el-input v-model="ruleForm.qq_or_wechat" placeholder="请填写QQ或微信"></el-input></el-form-item>
            <el-form-item label="擅长语种" prop="adept_lang" :class="{other:other.language.status}">
                <el-select v-model="ruleForm.adept_lang" clearable  placeholder="请选择擅长语种" @change="choseEvent('language', ruleForm.adept_lang)">
                    <el-option v-for="item in languageList" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                    <el-option label="其它" value="-1"></el-option>
                </el-select>
                <el-input placeholder="请输入擅长语种" style="display: none" v-model="other.language.content"></el-input>
            </el-form-item>
            <el-form-item label="擅长领域" prop="adept_fields" style="margin-bottom: 20px">
                <el-select v-model="ruleForm.adept_fields" multiple placeholder="请选择擅长领域" @change="choseFieldEvent">
                    <el-option v-for="item in fieldList" :key="item.id" :label="item.name" :value="item.name">
                    </el-option>
                    <el-option label="其它" value="-1"></el-option>
                </el-select>
            </el-form-item>
            <div class="areas" v-if="other.areasOfExpertise.status">
                <p v-for="(item,index) in other.areasOfExpertise.content" :key="index" style="margin-bottom: 10px">
                    <el-input v-model="item.name" placeholder="请输入领域名称" clearable></el-input>
                </p>
            </div>
            <el-form-item label="所获证书" prop="had_certificates" style="margin-bottom: 20px">
                <el-select v-model="ruleForm.had_certificates" multiple  placeholder="请选择所获证书"
                           @change="choseEvent('certificate', ruleForm.had_certificates)">
                    <el-option v-for="item in certificateList" :key="item.id" :label="item.name" :value="item.name"></el-option>
                    <el-option label="其它" value="-1"></el-option>
                </el-select>
            </el-form-item>
            <div class="certList" v-if="ruleForm.had_certificates&&ruleForm.had_certificates.length>0">
                <p v-for="(item,index) in ruleForm.had_certificates" :key="item">
                    <input type="text" :value="item" :v-model="item" v-if="!include(item, certificateList)" @blur="changeCertName($event, item, index)" placeholder="请输入证书名称">
                    <span v-if="include(item, certificateList)">{{item}}:</span>
                    <label for="fileInput" title="点击修改文件">
                        <input type="button" value="点击上传证书文件" v-if="!certList[index].file_name"><span v-if="certList[index].file_name">{{certList[index].file_name}}</span>
                        <input type="file" @change="uploadCert(item, $event)" class="fileInput">
                    </label>
                </p>
            </div>
            <el-form-item label="期望费率" prop="rate" class="payment">
                <el-input v-model="ruleForm.rateStart" placeholder="最低期望费率"></el-input> -
                <el-input v-model="ruleForm.rate" placeholder="最高期望费率">
                    <span class="KWord" slot="append">元/1000字</span>
                    <el-select v-model="ruleForm.charge_id" slot="append" placeholder="请选择">
                        <el-option v-for="item in billingMethod" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-input>


            </el-form-item>
            <el-form-item label="上传简历" prop="resume">
                <div class="uploadResume">
                    <el-upload class="avatar-uploader" action="/" :http-request="uploadResumeFile" :show-file-list="false">
                            <span class="fileName" v-if="ruleForm.resume">
                                <span class="el-icon-success"></span>
                                <span v-if="ruleForm.resume.name">{{ruleForm.resume.name}}</span>
                                <span v-else>{{ruleForm.resume.file_name}}</span>
                            </span>
                        <span class="uploadTips" v-else>点击上传</span>
                    </el-upload>
                </div>
            </el-form-item>
            <el-form-item label="上传翻译样例" prop="trans_example" class="translationExample">
                <div class="uploadTranslationExample">
                    <el-upload class="avatar-uploader" action="/" :http-request="uploadExampleFile" :show-file-list="false">
                        <span class="uploadTips">点击上传</span>
                    </el-upload>
                </div>
                <div class="mark">
                    <p>翻译样例需要上传</p>
                    <p>原文译文对照版本</p>
                </div>
            </el-form-item>
            <div class="exampleList">
                <p v-for="(item,index) in ruleForm.trans_example">
                    <span>{{(index+1)+ '. ' +item.file_name}}</span>
                    <span class="remove el-icon-circle-close" @click="removeExampleFile(index)" >
                        </span>
                </p>
            </div>
        </el-form>

        <div class="submitBtn" @click="submitForm('ruleForm')">确认修改</div>
    </div>
</template>

<script>
    import {isEmail, isMobile, isNumber} from "../../utils/check";
    import {modifyInfo} from "../../api/ImproveInformation";
    import {getProfile} from "../../api/translator";

    export default {
        name: "modifyInfomationForm",
        props:['languageList', 'fieldList', 'certificateList', "billingMethod"],
        data(){
            var checkPhone = (rule, value, callback) => {
                if (!value) {return callback(new Error('请输入您的手机号码'));}
                else {
                    if (isMobile(value)) {callback();
                    } else {return callback(new Error('请输入正确的手机号'));}
                }
            };
            var checkEmail = (rule, value, callback) =>{
                if (!value) {return callback(new Error('请输入您的邮箱'));}
                else{
                    if(isEmail(value)){callback()}
                    else{
                        return callback(new Error("请输入正确的邮箱"))
                    }
                }
            };
            var checkMoney = (rule, value, callback)=>{
                if (!value) {return callback(new Error('请输入您的期望费率'));}
                else {
                    if(isNumber(value)){callback()}
                    else {
                        return callback(new Error("期望费率为正整数"))
                    }
                }
            }
            return{
                ruleForm:{
                },
                rules:{
                    fullname:[{ required: true, message: '请输入您的名称', trigger: 'blur' },],
                    mobile:[{validator:checkPhone, trigger: 'blur'},{ required: true, trigger: 'blur' },],
                    email:[{validator:checkEmail, trigger: 'blur'},{ required: true, trigger: 'blur' },],
                    qq_or_wechat:[{ required: true, trigger: 'blur', message:'请输入您的QQ或微信'},],
                    adept_lang: [{ required: true, message: '请选择擅长语言', trigger: 'change' }],
                    adept_fields: [{ required: true, message: '请选择擅长领域', trigger: 'change' }],
                    had_certificates: [{ required: true, message: '请选择所获证书', trigger: 'change' }],
                    rate: [{ validator: checkMoney, trigger: 'change'}],
                    resume:[{ required: true, message: '请上传简历', trigger: 'change' }],
                    trans_example:[{ required: true, message: '请上传翻译样例', trigger: 'change' }],
                },
                // 其它
                other:{
                    language:{
                        status: false,
                        content: ""
                    },
                    areasOfExpertise:{
                        status: false,
                        content: [{name:""},{name:""},{name:""},{name:""},{name:""}]
                    },
                    certificate:{
                        status: false,
                        content: ""
                    }
                },
                certList:[],
                profile:'',
                deleted_examples:[],
                tempCert:[]
            }
        },
        methods:{
            // 更改擅长领域事件
            choseFieldEvent(value){
                // 先看看 当前选中的值是不是其它
                if(value[value.length-1] === "-1"){
                    this.other.areasOfExpertise.status = true
                    // console.log("other")
                }else{
                    // 当前选择的值不是其它，看看是否删除其它了
                    if(value.indexOf("-1")==-1){
                        this.other.areasOfExpertise.status = false
                        // console.log("当前没选择其它")
                    }else {
                        if(!this.other.areasOfExpertise.status){
                            // console.log(123)
                            this.other.areasOfExpertise.status = true
                        }
                        // console.log("其它为选择状态")
                    }
                }
            },
            changAreaName(e, item, index){
                if(!this.include(item, this.fieldList)){
                    this.ruleForm.adept_fields[index] = e.target.value.replace(/(^\s*)|(\s*$)/g, "")
                    let target = JSON.stringify(this.ruleForm.adept_fields);
                    this.$set(this.ruleForm, "adept_fields", JSON.parse(target))
                }else{
                    this.$message.info("该领域已存在，无需手动输入")
                }
            },
            changeCertName(e, item, index){
                if(!this.include(item, this.certificateList)){
                    this.ruleForm.had_certificates[index] = e.target.value.replace(/(^\s*)|(\s*$)/g, "")
                    this.certList[index].cer_name = this.ruleForm.had_certificates[index];
                    this.certList[index].has_change = true;
                    let target = JSON.stringify(this.ruleForm.had_certificates);
                    this.$set(this.ruleForm, "had_certificates", JSON.parse(target))
                }else{
                    this.$message.info("该证书已存在，无需手动输入")
                }
            },
            include(name, array){
                for(let i=0; i<array.length;i++){
                    if(array[i].name == name){
                        return true
                    }
                }
                return false
            },
            uploadCert(name, fileDom){
                if(fileDom.target.files.length>0){
                    if(name&&name!=" "){
                        this.certList.forEach(item=>{
                            if(item.cer_name == name){
                                item.has_change=true;
                                item.file_name = fileDom.target.files[0].name;
                                item.file = fileDom.target.files[0]
                            }
                        })
                        // this.certList[name] = {name:name, file:fileDom.target.files[0], file_name:fileDom.target.files[0].name}
                        this.$forceUpdate()
                    }else {
                        this.$message.warning("请先填写证书名称")
                    }
                }
            },
            // 选择其它时的事件
            choseEvent(key, value){
                if(key=="certificate"){
                    if(this.ruleForm.had_certificates.length<=0){
                        this.certList = [];
                        this.tempCert = []
                    }
                }
                /*
                    @key: 所属于的哪个事件
                    @value: 选择的状态
                 */
                if(Array.isArray(value)){
                    try{
                        value.forEach((item,index)=>{
                            if(key=="certificate"){
                                if(item==""){
                                    this.$message.warning("请先完善证书名称")
                                    this.ruleForm.had_certificates.splice(this.ruleForm.had_certificates.length-1, 1)
                                } else if(item==-1){
                                    this.other[key].status = true;
                                    this.ruleForm.had_certificates.splice(this.ruleForm.had_certificates.length-1,1,"");
                                    let newCert = {}
                                    newCert['cer_name'] = "";
                                    this.certList.push(newCert)

                                    // 删除
                                    this.certList.forEach((item, index)=>{
                                        if(this.ruleForm.had_certificates.indexOf(item.cer_name) > -1){
                                            this.certList.splice(index, 1)
                                        }
                                    })
                                    throw new Error('item == other')
                                }else{
                                    let newCert = {}
                                    let choseValue = value[value.length-1];
                                    newCert['cer_name'] = choseValue;
                                    newCert['file_name'] = "";

                                    if(choseValue==-1){
                                        this.ruleForm.had_certificates.splice(this.ruleForm.had_certificates.length-1,1,"");
                                        newCert['cer_name'] = "";
                                        this.certList.push(newCert)
                                    }

                                    // 如果当前最后一个存在于之前的临时变量中，则为旧数据不push,反之则push
                                    if(choseValue!=-1 && this.tempCert.indexOf(choseValue) <= -1){
                                        this.certList.push(newCert)
                                    }
                                    // if(choseValue==this.ruleForm.had_certificates[this.ruleForm.had_certificates.length-1]){
                                    //     this.certList.push(newCert)
                                    // }
                                    // if(this.ruleForm.had_certificates.indexOf(choseValue)<=-1){
                                    //     this.certList.push(newCert)
                                    // }
                                    this.tempCert = this.ruleForm.had_certificates;

                                    // 删除
                                    if(this.ruleForm.had_certificates.length<=0){
                                        this.certList = []
                                    }
                                    this.certList.forEach((item, index)=>{
                                        if(this.ruleForm.had_certificates.indexOf(item.cer_name) < 0){
                                            this.certList.splice(index, 1)
                                        }
                                    })

                                    throw new Error('item == other')
                                }
                            }
                            if(key=="areasOfExpertise"){
                                if(item==""){
                                    this.$message.warning("请先完善领域名称")
                                    this.ruleForm.areasOfExpertise.splice(this.ruleForm.areasOfExpertise.length-1, 1)
                                } else if(item=="-1"){
                                    this.other[key].status = true;
                                    this.ruleForm.adept_fields.splice(this.ruleForm.adept_fields.length-1,1,"")
                                    throw new Error('item == other')
                                }else{
                                    this.other[key].status = false;
                                }
                            }
                        })


                    }catch (e) {
                        if(e.message != "item == other") throw e
                        // if(e.message != 'item == other' || e.message != 'item == neizhi') throw e
                    }

                }else{
                    this.other[key].status  = value == -1 ? true : false;
                }
                this.$forceUpdate();
            },
            // 上传简历
            uploadResumeFile(fileObj){
                this.ruleForm.resume = fileObj.file;
            },
            // 上传删除翻译样例
            uploadExampleFile(fileObj){
                this.ruleForm.trans_example.push({file:fileObj.file, file_name:fileObj.file.name})
            },
            removeExampleFile(index){
                this.deleted_examples.push(this.ruleForm.trans_example[index].id)
                this.ruleForm.trans_example.splice(index, 1)
            },
            // 确认提交表单
            submitForm(formName){
                this.$refs[formName].validate((valid) => {
                    if (valid) {

                        // 此时， 再向后端传值的时候，就所获证书字段--用处理后的数据， 其余字段可以直接使用ruleForm的字段
                        // 获取到对应的证书文件，组成一个新数组 用于传给后端【不影响前台显示， 选择领域和语种时可以参考此组成一个新的数组，单独用来传给后端】
                        let newCertList=[];
                        this.ruleForm.had_certificates.forEach((item,index)=>{
                            if(this.certList[index].cer_name == item && this.certList[index].file_name){
                                newCertList.push(this.certList[index])
                            }else {
                                this.$message.warning("请上传对应的证书文件")
                                throw new Error("请上传对应的证书文件")
                            }
                        })
                        this.ruleForm['newCertList'] = newCertList
                        // console.log(newCertList)

                        if(this.other.areasOfExpertise.status){
                            // 其它领域时，不能不填
                            let target = this.other.areasOfExpertise.content;
                            let source = [{name:""},{name:""},{name:""},{name:""},{name:""}];
                            if(JSON.stringify(target) == JSON.stringify(source)){
                                this.$message.warning("请填写您擅长的其它领域")
                                return false
                            }
                        }

                        // send request
                        // console.log(this.ruleForm)
                        modifyInfo(this.ruleForm, this.profile, this.other.language, this.deleted_examples, this.other.areasOfExpertise)
                        .then(data=>{
                            window.location.href = "/translator/material"
                        })
                        .catch(error=>{
                            console.log(error)
                            this.$message.error(error.data.error)
                        })

                    } else {
                        this.$message.warning("请根据提示完善个人信息后再提交~")
                        return false;
                    }
                });
            },
            // 获取用户已填写信息
            async getProfileEvent(){
                await getProfile()
                    .then(data=>{
                        this.ruleForm = data;
                        this.profile = data;
                        // 擅长语种
                        if(this.ruleForm.adept_lang[0].is_other){
                            this.other.language.content = this.ruleForm.adept_lang[0].name
                            this.ruleForm.adept_lang = "-1";
                            this.other.language.status = true;
                        }else{
                            this.ruleForm.adept_lang = this.ruleForm.adept_lang[0].name
                        }


                        // let fieldData = JSON.stringify(this.ruleForm.adept_fields);
                        // fieldData = JSON.parse(fieldData)
                        let fieldData = []

                        // 擅长擅长领域
                        let otherFields = []
                        this.ruleForm.adept_fields.forEach((item, index)=>{
                            if(item.is_other){
                                otherFields.push({name:item.name})
                            }else{
                                fieldData.push(item.name)
                            }
                        })
                        this.ruleForm.adept_fields = fieldData
                        this.other.areasOfExpertise.content = otherFields;
                        if(this.other.areasOfExpertise.content.length>0){
                            this.other.areasOfExpertise.status = true;
                            this.ruleForm.adept_fields.push("-1")
                        }
                        for(let i =0; i<=(5-this.other.areasOfExpertise.content.length); i++ ){
                            this.other.areasOfExpertise.content.push({name:""})
                        }
                        this.$forceUpdate()

                        // this.ruleForm.adept_fields = fields;
                        // 证书
                        this.certList = this.ruleForm.had_certificates;
                        let cert = [];
                        this.ruleForm.had_certificates.forEach(item=>{
                            cert.push(item.cer_name)
                        })
                        this.ruleForm.had_certificates = cert;
                        this.tempCert = cert;
                        // 费率
                        this.$set(this.ruleForm, "rateStart", this.ruleForm)
                        this.$set(this.ruleForm, "rate", this.ruleForm)
                        this.$set(this.ruleForm, "charge_id", this.ruleForm)
                        let money = this.ruleForm.expected_rates.rate.split('-');
                        if(money.length<=1){
                            this.ruleForm.rateStart = 0;
                            this.ruleForm.rate = money[0];
                        }else{
                            this.ruleForm.rateStart = money[0];
                            this.ruleForm.rate = money[1];
                        }
                        this.ruleForm.charge_id = this.ruleForm.expected_rates.charge_id;

                    })
                    .catch(error=>{
                        console.log(error)
                        this.$message.error(error.data.error)
                    })
            }
        },
        created() {
            this.getProfileEvent()
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/ImproveInformation/index.scss";
</style>